<ng-container *ngIf="medias && medias.length > 0; else noMediaBlock">
  <app-attachment [media]="media" *ngFor="let media of medias"></app-attachment>
</ng-container>

<ng-template #noMediaBlock>
  <app-attachment [media]="null"></app-attachment>
</ng-template>
